import React from "react";
import "./App.css";
import Graph from "react-graph-vis";

function App() {
  const styleNodes = (node) => {
    if (node.id === "AlleyCorp") {
      return Object.assign(node, nodeAlleyCorp);
    } else if (
      node.id === "DoubleClick" ||
      node.id === "MongoDB" ||
      node.id === "Business Insider" ||
      node.id === "Gilt Groupe" ||
      node.id === "Zola" ||
      node.id === "Truebird" ||
      node.id === "Nomad Health" ||
      node.id === "Coedition"
    ) {
      return Object.assign(node, nodeFounded);
    }

    return Object.assign(node, nodeDefault);
  };

  const nodeAlleyCorp = {
    size: 25,
    color: "#001b44",
    font: {
      size: 24,
    },
  };

  const nodeFounded = {
    size: 15,
    color: "#357edd",
    font: {
      size: 18,
    },
  };

  const nodeDefault = {
    size: 5,
    color: "#96ccff",
    font: {
      size: 14,
    },
  };

  const options = {
    layout: {
      hierarchical: false,
    },
    nodes: {
      shape: "dot",
    },
    edges: {
      color: "#000000",
      smooth: true,
    },
  };

  const graph = {
    edges: [
      {
        from: "AlleyCorp",
        to: "Doubleclick",
      },
      {
        from: "AlleyCorp",
        to: "MongoDB",
      },
      {
        from: "AlleyCorp",
        to: "Gilt Groupe",
      },
      {
        from: "AlleyCorp",
        to: "Business Insider",
      },
      {
        from: "AlleyCorp",
        to: "Nomad Health",
      },
      {
        from: "AlleyCorp",
        to: "Coedition",
      },
      {
        from: "AlleyCorp",
        to: "Truebird",
      },
      {
        from: "AlleyCorp",
        to: "Zola",
      },
      {
        from: "DoubleClick",
        to: "GroupCommerce",
      },
      {
        from: "DoubleClick",
        to: "Zipdrug",
      },
      {
        from: "DoubleClick",
        to: "Telaria",
      },
      {
        from: "DoubleClick",
        to: "Narrative Science",
      },
      {
        from: "DoubleClick",
        to: "Phanfare",
      },
      {
        from: "DoubleClick",
        to: "Shopwiki",
      },
      {
        from: "DoubleClick",
        to: "Movable Ink",
      },
      {
        from: "DoubleClick",
        to: "Opensky",
      },
      {
        from: "DoubleClick",
        to: "Timehop",
      },
      {
        from: "DoubleClick",
        to: "Moda Operandi",
      },
      {
        from: "DoubleClick",
        to: "Vaunte",
      },
      {
        from: "DoubleClick",
        to: "Placemeter",
      },
      {
        from: "DoubleClick",
        to: "Minibar Delivery",
      },
      {
        from: "DoubleClick",
        to: "MongoDB",
      },
      {
        from: "DoubleClick",
        to: "Gilt Groupe",
      },
      {
        from: "Gilt Groupe",
        to: "Security Scorecard",
      },
      {
        from: "Gilt Groupe",
        to: "Blade",
      },
      {
        from: "Gilt Groupe",
        to: "Splice",
      },
      {
        from: "Gilt Groupe",
        to: "Flow.io",
      },
      {
        from: "Gilt Groupe",
        to: "Daily Harvest",
      },
      {
        from: "Gilt Groupe",
        to: "Zola",
      },
      {
        from: "Gilt Groupe",
        to: "Glamsquad",
      },
      {
        from: "Gilt Groupe",
        to: "Fitz",
      },
      {
        from: "Gilt Groupe",
        to: "CodeClimate",
      },
      {
        from: "Gilt Groupe",
        to: "Nara Organics",
      },
      {
        from: "Gilt Groupe",
        to: "Transfix",
      },
      {
        from: "Gilt Groupe",
        to: "Coedition",
      },
      {
        from: "Gilt Groupe",
        to: "Bravely",
      },
      {
        from: "MongoDB",
        to: "Oso",
      },
      {
        from: "MongoDB",
        to: "Hustle",
      },
      {
        from: "MongoDB",
        to: "Elpha",
      },
      {
        from: "Business Insider",
        to: "ChartHop",
      },
      {
        from: "Business Insider",
        to: "Digital Ocean",
      },
      {
        from: "Zola",
        to: "Great Jones",
      },
      {
        from: "DoubleClick",
        to: "Meetup",
      },
      {
        from: "AlleyCorp",
        to: "DoubleClick",
      },
    ],
    nodes: [
      {
        id: "AlleyCorp",
        label: "AlleyCorp",
        title: "AlleyCorp",
      },
      {
        id: "Transfix",
        label: "Transfix",
        title: "Transfix",
      },
      {
        id: "Digital Ocean",
        label: "Digital Ocean",
        title: "Digital Ocean",
      },
      {
        id: "DoubleClick",
        label: "DoubleClick",
        title: "DoubleClick",
      },
      {
        id: "Meetup",
        label: "Meetup",
        title: "Meetup",
      },
      {
        id: "Gilt Groupe",
        label: "Gilt Groupe",
        title: "Gilt Groupe",
      },
      {
        id: "MongoDB",
        label: "MongoDB",
        title: "MongoDB",
      },
      {
        id: "Business Insider",
        label: "Business Insider",
        title: "Business Insider",
      },
      {
        id: "Nomad Health",
        label: "Nomad Health",
        title: "Nomad Health",
      },
      {
        id: "Coedition",
        label: "Coedition",
        title: "Coedition",
      },
      {
        id: "Truebird",
        label: "Truebird",
        title: "Truebird",
      },
      {
        id: "GroupCommerce",
        label: "GroupCommerce",
        title: "GroupCommerce",
      },
      {
        id: "Zipdrug",
        label: "Zipdrug",
        title: "Zipdrug",
      },
      {
        id: "Telaria",
        label: "Telaria",
        title: "Telaria",
      },
      {
        id: "Narrative Science",
        label: "Narrative Science",
        title: "Narrative Science",
      },
      {
        id: "Phanfare",
        label: "Phanfare",
        title: "Phanfare",
      },
      {
        id: "Shopwiki",
        label: "Shopwiki",
        title: "Shopwiki",
      },
      {
        id: "Movable Ink",
        label: "Movable Ink",
        title: "Movable Ink",
      },
      {
        id: "Opensky",
        label: "Opensky",
        title: "Opensky",
      },
      {
        id: "Timehop",
        label: "Timehop",
        title: "Timehop",
      },
      {
        id: "Moda Operandi",
        label: "Moda Operandi",
        title: "Moda Operandi",
      },
      {
        id: "Vaunte",
        label: "Vaunte",
        title: "Vaunte",
      },
      {
        id: "Placemeter",
        label: "Placemeter",
        title: "Placemeter",
      },
      {
        id: "Minibar Delivery",
        label: "Minibar Delivery",
        title: "Minibar Delivery",
      },
      {
        id: "Security Scorecard",
        label: "Security Scorecard",
        title: "Security Scorecard",
      },
      {
        id: "Blade",
        label: "Blade",
        title: "Blade",
      },
      {
        id: "Splice",
        label: "Splice",
        title: "Splice",
      },
      {
        id: "Flow.io",
        label: "Flow.io",
        title: "Flow.io",
      },
      {
        id: "Daily Harvest",
        label: "Daily Harvest",
        title: "Daily Harvest",
      },
      {
        id: "Zola",
        label: "Zola",
        title: "Zola",
      },
      {
        id: "Glamsquad",
        label: "Glamsquad",
        title: "Glamsquad",
      },
      {
        id: "Fitz",
        label: "Fitz",
        title: "Fitz",
      },
      {
        id: "CodeClimate",
        label: "CodeClimate",
        title: "CodeClimate",
      },
      {
        id: "Nara Organics",
        label: "Nara Organics",
        title: "Nara Organics",
      },
      {
        id: "Bravely",
        label: "Bravely",
        title: "Bravely",
      },
      {
        id: "Oso",
        label: "Oso",
        title: "Oso",
      },
      {
        id: "Hustle",
        label: "Hustle",
        title: "Hustle",
      },
      {
        id: "Elpha",
        label: "Elpha",
        title: "Elpha",
      },
      {
        id: "ChartHop",
        label: "ChartHop",
        title: "ChartHop",
      },
      {
        id: "Great Jones",
        label: "Great Jones",
        title: "Great Jones",
      },
    ].map(styleNodes),
  };

  const events = {
    select: function (event) {
      var { nodes, edges } = event;
    },
  };

  return (
    <div className={`relative w-100 courier`}>
      <div
        className={`absolute z-999 center shadow-5 pv2 ph4 bg-white measure-narrow top-2 right-2`}
      >
        <h1 className={`f5 tc`}>AlleyCorp Ecosystem</h1>
        <p className={`f6 pb2 lh-copy`}>
          Responsible for founding and funding some of the earliest tech
          companies in New York, AlleyCorp now sits at the center of a robust -
          and growing - tech ecosystem.
        </p>
        <div className={`f6 dt`}>
          <div className={`dt-row`}>
            <div className={`dtc pb2 v-mid`}>
              <div className={`br-100 bg-navy w1 h1`}></div>
            </div>
            <div className={`dtc pl2`}>AlleyCorp</div>
          </div>
          <div className={`dt-row`}>
            <div className={`dtc pb2 v-mid`}>
              <div className={`br-100 bg-blue w1 h1`}></div>
            </div>{" "}
            <div className={`dtc pl2`}>Co-founded by AlleyCorp</div>
          </div>
          <div className={`dt-row`}>
            <div className={`dtc pb2 v-mid`}>
              <div className={`br-100 bg-light-blue w1 h1`}></div>
            </div>{" "}
            <div className={`dtc pl2`}>
              Founded by employees of AlleyCorp companies
            </div>
          </div>
        </div>
        <p className={`w-100 tc f7 pt2`}>
          <a href="https://alleycorp.com" target="_blank">
            Return to AlleyCorp Site
          </a>
        </p>
      </div>
      <div className={`ba b--black vh-100 w-100 bg-washed-blue`}>
        <Graph
          graph={graph}
          options={options}
          events={events}
          getNetwork={(network) => {
            //  if you want access to vis.js network api you can set the state in a parent component using this property
          }}
        />
      </div>
    </div>
  );
}

export default App;
